import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/user.service';
import { ToastContainerDirective } from 'ngx-toastr';

export enum PaymentType {
  BONIFICO = 'bonifico',
  PAYPAL = 'paypal'
}

@Component({
  selector: 'wsb-partner-payment-modal',
  templateUrl: './partner-payment-modal.component.html',
  styleUrls: ['./partner-payment-modal.component.scss'],
  standalone: false
})
export class PartnerPaymentModalComponent implements OnInit {
  @ViewChild(ToastContainerDirective) modalToastContainer: ToastContainerDirective;
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  @Input() public title;
  @Input() public text;
  @Input() public alertText;
  @Input() public labelCancelButton = 'common_cancel';
  @Input() public labelSendButton = 'common_send';

  @Output() send: EventEmitter<any> = new EventEmitter();
  @Output() cancelEvent: EventEmitter<any> = new EventEmitter();

  payoutForm: UntypedFormGroup;
  isPaypal = false;

  constructor(private formBuilder: UntypedFormBuilder, public activeModal: NgbActiveModal, public userService: UserService) {}

  ngOnInit(): void {
    this.payoutForm = this.buildPayoutForm();
    this.resetFieldsWhenChangePaymentType();
  }

  private resetFieldsWhenChangePaymentType() {
    this.get('paymentType').valueChanges.subscribe(() => {
      this.resetPaymentDetailsFields();
      this.resetBankNameFields();
      this.setValidatorByPaymentTypeValue();
    });
  }

  private setValidatorByPaymentTypeValue() {
    if (this.getValue('paymentType') === PaymentType.BONIFICO) {
      this.get('jsonPaymentDetails.iban').setValidators(Validators.required);
      this.get('jsonPaymentDetails.iban').updateValueAndValidity();
      this.get('jsonPaymentDetails.email').clearValidators();
    } else if (this.getValue('paymentType') === PaymentType.PAYPAL) {
      this.get('jsonPaymentDetails.email').setValidators(Validators.required);
      this.get('jsonPaymentDetails.email').updateValueAndValidity();
      this.get('jsonPaymentDetails.iban').clearValidators();
    }
  }

  private resetPaymentDetailsFields() {
    this.get('jsonPaymentDetails.email').setValue('');
    this.get('jsonPaymentDetails.iban').setValue('');
    this.get('jsonPaymentDetails.via').setValue('');
  }

  private resetBankNameFields() {
    this.get('name').setValue('');
  }

  private buildPayoutForm() {
    return this.formBuilder.group({
      documentType: [this.getInvonceByUserType()],
      paymentType: [PaymentType.BONIFICO],
      name: [''],
      jsonPaymentDetails: this.formBuilder.group({
        email: ['', []],
        iban: ['', [Validators.required]],
        via: ['']
      })
    });
  }

  getChosenPaymentMethod() {
    return this.getValue('paymentType');
  }

  private get(value: string) {
    return this.payoutForm.get(value);
  }

  private getValue(value: string) {
    return this.get(value).value;
  }

  btnSend() {
    const sendPayout = this.payoutForm.getRawValue();
    return sendPayout;
  }

  private getInvonceByUserType() {
    console.log(this.userService.isPrivate());
    if (this.userService.isPrivate()) {
      return 'ricevuta fiscale';
    }
    return 'fattura';
  }
}
